import api, { ResponsePayloadWithData } from '../../../api';

type School = {
  id: string;
  name: string;
  cities?: string;
  isSmartschool: boolean;
};

export type StudentGroup = {
  id: string;
  name: string;
  school: School;
  subjects: string[];
  schoolYear: string;
  smartschoolGroupId?: string;
  owner: {
    id: string;
    firstName: string;
    lastName: string;
  };
};

export async function fetchStudentGroups(schoolYear: string): Promise<StudentGroup[]> {
  const {
    data: { data },
  } = await api.get<ResponsePayloadWithData<StudentGroup[]>>(
    `studio/user/school-years/${schoolYear}/groups?studioGroup=${process.env.REACT_APP_P_STUDIO_GROUP}`,
  );

  return data;
}

export async function declineGroupInvite(invitationId: string): Promise<void> {
  await api.delete(`studio/user/invites/${invitationId}`);
}

export async function acceptGroupInvite(invitationId: string): Promise<StudentGroup> {
  const { data } = await api.put<StudentGroup>(`studio/user/invites/${invitationId}/accept`);

  return data;
}

export async function disconnectGroup(groupId: string): Promise<void> {
  await api.delete(`studio/user/groups/${groupId}`);
}
